export default function IndexPage() {


    return <div className="page-content">
        <h1>PCK AS</h1>
        <p>Hei! Her er det ikke så mye å se enda. Disse sidene er enda under utvikling.</p>
        <hr/>
        <p>Du kan se programendringer for våre løsninger her:<br />
            <a href="/program-changes">Program endringer</a>
        </p>
    </div>
}
